"use client";

import React, { useId } from "react";

interface GridBackgroundProps {
	className?: string;
	opacity?: number;
}

export function GridBackground({
	className = "",
	opacity = 0.11,
}: GridBackgroundProps) {
	const uniqueId = useId();
	const clipId = `clip0_grid_bg_${uniqueId}`;
	const maskId = `mask0_grid_bg_${uniqueId}`;
	const paint0Id = `paint0_linear_grid_bg_${uniqueId}`;

	return (
		<div className={`absolute inset-0 ${className}`}>
			<svg
				width="100%"
				height="100%"
				viewBox="0 0 1220 810"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="xMidYMid slice"
				aria-hidden="true"
			>
				<title>Grid Background Pattern</title>
				<g clipPath={`url(#${clipId})`}>
					<mask
						id={maskId}
						style={{ maskType: "alpha" }}
						maskUnits="userSpaceOnUse"
						x="10"
						y="-1"
						width="1200"
						height="812"
					>
						<rect
							x="10"
							y="-0.84668"
							width="1200"
							height="811.693"
							fill={`url(#${paint0Id})`}
						/>
					</mask>
					<g mask={`url(#${maskId})`}>
						{/* Grid Rectangles */}
						{[...Array(35)].map((_, i) => (
							<React.Fragment key={`grid-row-${uniqueId}-${i}`}>
								{[...Array(23)].map((_, j) => (
									<rect
										key={`grid-cell-${uniqueId}-${i}-${j}`}
										x={-20.0891 + i * 36}
										y={9.2 + j * 36}
										width="35.6"
										height="35.6"
										stroke="hsl(var(--foreground))"
										strokeOpacity={opacity}
										strokeWidth="0.4"
										strokeDasharray="2 2"
									/>
								))}
							</React.Fragment>
						))}

						{/* Specific Rectangles with fill - accent cells */}
						<rect
							x="699.711"
							y="81"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.08"
						/>
						<rect
							x="195.711"
							y="153"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.09"
						/>
						<rect
							x="1023.71"
							y="153"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.09"
						/>
						<rect
							x="123.711"
							y="225"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.09"
						/>
						<rect
							x="1095.71"
							y="225"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.09"
						/>
						<rect
							x="951.711"
							y="297"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.09"
						/>
						<rect
							x="231.711"
							y="333"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.07"
						/>
						<rect
							x="303.711"
							y="405"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.07"
						/>
						<rect
							x="87.7109"
							y="405"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.09"
						/>
						<rect
							x="519.711"
							y="405"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.08"
						/>
						<rect
							x="771.711"
							y="405"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.09"
						/>
						<rect
							x="591.711"
							y="477"
							width="36"
							height="36"
							fill="hsl(var(--foreground))"
							fillOpacity="0.07"
						/>
					</g>

					{/* Green light effect */}
					<rect
						width="100%"
						height="100%"
						fill={`url(#paint5_radial_green_light_${uniqueId})`}
						style={{ mixBlendMode: "screen" }}
					/>
				</g>

				{/* Border */}
				<rect
					x="0.5"
					y="0.5"
					width="1219"
					height="809"
					rx="15.5"
					stroke="hsl(var(--foreground))"
					strokeOpacity="0.06"
				/>

				<defs>
					<linearGradient
						id={paint0Id}
						x1="35.0676"
						y1="23.6807"
						x2="903.8"
						y2="632.086"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="hsl(var(--foreground))" stopOpacity="0" />
						<stop offset="1" stopColor="hsl(var(--muted-foreground))" />
					</linearGradient>
					<radialGradient
						id={`paint5_radial_green_light_${uniqueId}`}
						cx="0"
						cy="0"
						r="1"
						gradientUnits="userSpaceOnUse"
						gradientTransform="translate(1220 810) rotate(-135) scale(500 500)"
					>
						<stop stopColor="#ADF3E7" stopOpacity="0.7" />
						<stop offset="1" stopColor="#ADF3E7" stopOpacity="0" />
					</radialGradient>
					<clipPath id={clipId}>
						<rect
							width="1220"
							height="810"
							rx="16"
							fill="hsl(var(--foreground))"
						/>
					</clipPath>
				</defs>
			</svg>
		</div>
	);
}
